import { SxProps } from "@mui/material";

export const checkboxLabelStyle: SxProps = {
    color: "#888",
};

export const checkboxPadding: SxProps = {
    paddingLeft: "8px",
};